/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { ExperienceTaskCatalog } from './ExperienceTaskCatalog';
import {
    ExperienceTaskCatalogFromJSON,
    ExperienceTaskCatalogFromJSONTyped,
    ExperienceTaskCatalogToJSON,
    instanceOfExperienceTaskCatalog,
} from './ExperienceTaskCatalog';

/**
 * 
 * @export
 * @interface GetTaskCatalogForProjectResponseContent
 */
export interface GetTaskCatalogForProjectResponseContent {
    /**
     * 
     * @type {ExperienceTaskCatalog}
     * @memberof GetTaskCatalogForProjectResponseContent
     */
    experience: ExperienceTaskCatalog;
}


/**
 * Check if a given object implements the GetTaskCatalogForProjectResponseContent interface.
 */
export function instanceOfGetTaskCatalogForProjectResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "experience" in value;
    return isInstance;
}

export function GetTaskCatalogForProjectResponseContentFromJSON(json: any): GetTaskCatalogForProjectResponseContent {
    return GetTaskCatalogForProjectResponseContentFromJSONTyped(json, false);
}

export function GetTaskCatalogForProjectResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTaskCatalogForProjectResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'experience': ExperienceTaskCatalogFromJSON(json['experience']),
    };
}

export function GetTaskCatalogForProjectResponseContentToJSON(value?: GetTaskCatalogForProjectResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'experience': ExperienceTaskCatalogToJSON(value.experience),
    };
}

